import {useEffect} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {IRPStore} from "../app/rp_reducer";
import {viewSessionTimeHit} from "../tracking/algolytics_hits/view_session_time_hit";

export const useSessionTracking = () => {
    const currentViewType = useSelector((store: IRPStore) => store.viewType.current);
    const {pathname} = useLocation();

    useEffect(() => {
        let startTime = getCurrentTime();

        const sendHit = () => {
            const now = getCurrentTime();

            if (now < startTime) {
                return;
            }

            viewSessionTimeHit(startTime, now, pathname, currentViewType);
            startTime = now;
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                sendHit();
            } else {
                startTime = getCurrentTime();
            }
        };

        // pagehide (not beforeunload) - beforeunload is unreliable on mobile Safari and opts the
        // page out of the back-forward cache; visibilitychange usually already handled the hit
        // by the time pagehide fires, hence the guard.
        const handlePageHide = () => {
            if (!document.hidden) {
                sendHit();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handlePageHide);
            sendHit();
        };
    }, [pathname]);
};

function getCurrentTime() {
    return new Date().getTime();
}
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {IRPStore} from "../app/rp_reducer";
import {viewSessionTimeHit} from "../tracking/algolytics_hits/view_session_time_hit";

export const useSessionTracking = () => {
    const currentViewType = useSelector((store: IRPStore) => store.viewType.current);
    const {pathname} = useLocation();

    useEffect(() => {
        let startTime = getCurrentTime();

        const sendHit = () => {
            const now = getCurrentTime();

            if (now < startTime) {
                return;
            }

            viewSessionTimeHit(startTime, now, pathname, currentViewType);
            startTime = now;
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                sendHit();
            } else {
                startTime = getCurrentTime();
            }
        };

        // pagehide (not beforeunload) - beforeunload is unreliable on mobile Safari and opts the
        // page out of the back-forward cache; visibilitychange usually already handled the hit
        // by the time pagehide fires, hence the guard.
        const handlePageHide = () => {
            if (!document.hidden) {
                sendHit();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handlePageHide);
            sendHit();
        };
    }, [pathname]);
};

function getCurrentTime() {
    return new Date().getTime();
}
